// extracted by mini-css-extract-plugin
export default {"upgrade":"styles_upgrade__cJNYP","upgradeText":"styles_upgradeText__dI6UR","upgradeBtn":"styles_upgradeBtn__rt2qv"};